import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
import { Paprika } from '../../styles/theme';

/**
 * Du Chef mark — the house from the app icon, reduced to the part that still
 * reads at 28px. The chimney is a solid block rather than an outline: at this
 * size an outlined one collapses into a smear.
 *
 * Colors derive from the design tokens so a theme change is one edit.
 */
export const DuChefMark: React.FC<{ size?: number; opacity?: number }> = ({ size = 28, opacity = 1 }) => (
  <Svg width={size} height={size} viewBox="0 0 32 32" fill="none" opacity={opacity}>
    {/* Drawn before the roof so the roof stroke closes off its base. */}
    <Rect x={21.4} y={8.2} width={3.4} height={8.5} rx={0.8} fill={Paprika.accent} />
    <Path
      d="M5 26.5 L5 17.8 L16 7.4 L27 17.8 L27 26.5"
      stroke={Paprika.accent}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

/**
 * Multicolor Google "G" — standard 4-color logo (from the handoff kit).
 */
export const GoogleG: React.FC<{ size?: number }> = ({ size = 18 }) => (
  <Svg width={size} height={size} viewBox="0 0 48 48">
    <Path
      fill="#EA4335"
      d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6.1C12.3 13.3 17.6 9.5 24 9.5Z"
    />
    <Path
      fill="#4285F4"
      d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.5 3-2.2 5.5-4.7 7.2l7.3 5.7c4.3-4 6.9-9.9 6.9-17.4Z"
    />
    <Path
      fill="#FBBC05"
      d="M10.4 28.7c-.5-1.4-.7-2.9-.7-4.7s.3-3.3.7-4.7l-7.8-6.1C.9 16.4 0 20.1 0 24s.9 7.6 2.6 10.8l7.8-6.1Z"
    />
    <Path
      fill="#34A853"
      d="M24 48c6.2 0 11.4-2 15.2-5.6l-7.3-5.7c-2 1.4-4.7 2.3-7.9 2.3-6.4 0-11.7-3.8-13.6-9.3l-7.8 6.1C6.5 42.6 14.6 48 24 48Z"
    />
  </Svg>
);
